// applyTenantBaseline — the baseline registrations that must run AFTER VLT.
//
// VLT registers its own headerTools/Anontools slot component during its
// config phase; a registration from an addon loaded before VLT is silently
// overridden (the reason the fleet's UserTools registration historically
// lived in each tenant addon — volto-wantai/volto-yizhou comments, s525).
// Centralizing the registration HERE and having the TENANT addon call this
// from its applyConfig (outermost addon = runs last) keeps both invariants:
// VLT stays last in addons[] (AIV-2026-024) and the baseline wins the slot.
//
// Per-tenant usage (the tenant's entire baseline surface):
//   import { applyTenantBaseline } from 'volto-tenant-baseline/applyTenantBaseline';
//   config = applyTenantBaseline(config, { guidesSectorPath: '/medical' });

import UserTools from './components/UserTools';

export const applyTenantBaseline = (config, overrides = {}) => {
  config.settings.tenantBaseline = {
    ...(config.settings.tenantBaseline || {}),
    ...overrides,
  };

  // Token-truth UserTools over VLT's Anontools (BUG-2026-211 / BUG-2026-217 /
  // CR-2026-009 pattern): VLT's Anontools renders from the session-derived
  // @actions cache and goes stale on all-private tenants; session truth is
  // state.userSession.token. Same slot+name as VLT's own registration, so
  // this (later) registration wins. UserTools also renders the GuidesLink
  // element (DR-2026-272) — the fleet Guides entry lives in this cluster.
  config.registerSlotComponent({
    slot: 'headerTools',
    name: 'Anontools',
    component: UserTools,
  });

  return config;
};
